import React from "react";

export const FilterIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx="12" fill="#18428E" />
      <path
        d="M17 9.25H14"
        stroke="#FAFAFC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9.25H7"
        stroke="#FAFAFC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11C11.9665 11 12.75 10.2165 12.75 9.25C12.75 8.2835 11.9665 7.5 11 7.5C10.0335 7.5 9.25 8.2835 9.25 9.25C9.25 10.2165 10.0335 11 11 11Z"
        stroke="#FAFAFC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14.75H15"
        stroke="#FAFAFC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.75H7"
        stroke="#FAFAFC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 16.5C13.9665 16.5 14.75 15.7165 14.75 14.75C14.75 13.7835 13.9665 13 13 13C12.0335 13 11.25 13.7835 11.25 14.75C11.25 15.7165 12.0335 16.5 13 16.5Z"
        stroke="#FAFAFC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
